import { render, staticRenderFns } from "./hooyu-status.vue?vue&type=template&id=3ca500af&scoped=true"
import script from "./hooyu-status.vue?vue&type=script&lang=js"
export * from "./hooyu-status.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca500af",
  null
  
)

export default component.exports